export const config = {
    trackType: '千帆大模型服务与开发平台ModelBuilder',
    layout: 'wenxin',
    page: 'wenxin',
};

export const notice = {
    title: '最新通知',
    desc: '百度智能云千帆全面支持DeepSeek-R1/V3调用',
    link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/qm6oyumhw',
};

export const noticeList = [
    {
        title: '最新通知',
        desc: '百度智能云千帆全面支持DeepSeek-R1/V3调用',
        link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/qm6oyumhw',
    },
    // {
    //     title: '最新通知11',
    //     desc: 'ERNIE-4.0-Turbo-128K模型接口全新推出，长上下文场景效果更优',
    //     link: 'https://dwz.cn/Dh8wJKWo'
    // }
];

export const header = {
    logo: require('assets/wenxin/logo.png').default,
    buttonGroupRight: [
        {
            text: '返回百度智能云',
            href: 'https://cloud.baidu.com/',
            type: 'primary',
            class: 'back-btn',
            id: 0,
            trackInfo: {
                'data-track-category': '千帆产品页PC-顶部导航',
                'data-track-name': '返回百度智能云',
                'data-track-value': 'EMPTY',
            },
        },
        {
            text: '登录',
            href: 'https://login.bce.baidu.com/',
            // href: 'https://login.bce.baidu.com/?redirect=https%3A%2F%2Fcloud.baidu.com%2Fproduct%2Fwenxinworkshop',
            class: 'login-btn',
            id: 1,
            trackInfo: {
                'data-track-category': '千帆产品页PC-顶部导航',
                'data-track-name': '登录',
                'data-track-value': 'EMPTY',
            },
        },
        {
            text: '免费注册',
            href: 'https://login.bce.baidu.com/new-reg?tpl=bceplat&amp;from=portal',
            class: 'regist-btn',
            id: 2,
            trackInfo: {
                'data-track-category': '千帆产品页PC-顶部导航',
                'data-track-name': '免费注册',
                'data-track-value': 'EMPTY',
            },
        },
    ],
};

export const banner = {
    title: '千帆大模型服务与开发平台ModelBuilder',
    des: '文心大模型企业级服务唯一入口，提供高可用及高效价比的生成式AI服务及全流程模型开发工具链',
    buttonGroup: [
        {
            text: '立即使用',
            href: 'https://console.bce.baidu.com/qianfan/overview',
            type: 'primary',
            class: 'primary-btn',
            id: 0,
            trackInfo: {
                'data-track-category': '千帆产品页PC-banner',
                'data-track-name': '主按钮',
                'data-track-value': '立即使用',
            },
            trackInfo_m: {
                'data-track-category': '千帆产品页wise-banner',
                'data-track-name': '主按钮',
                'data-track-value': '立即使用',
            },
        },
        {
            text: '在线体验',
            href: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest',
            // href: 'https://qasandbox.bcetest.baidu.com/qianfan/modelcenter/model/buildIn/list',
            type: 'default',
            class: 'default-btn',
            id: 1,
            trackInfo: {
                'data-track-category': '千帆产品页PC-banner',
                'data-track-name': '主按钮',
                'data-track-value': '在线体验',
            },
            trackInfo_m: {
                'data-track-category': '千帆产品页wise-banner',
                'data-track-name': '主按钮',
                'data-track-value': '在线体验',
            },
        },

        {
            text: '企业咨询',
            href: 'https://cloud.baidu.com/survey/qianfanmb.html',
            type: 'default',
            class: 'default-btn',
            id: 2,
            trackInfo: {
                'data-track-category': '千帆产品页PC-banner',
                'data-track-name': '主按钮',
                'data-track-value': '企业咨询',
            },
            trackInfo_m: {
                'data-track-category': '千帆产品页wise-banner',
                'data-track-name': '主按钮',
                'data-track-value': '企业咨询',
            },
        },
    ],
};

export const productTitle = [
    {
        id: 0,
        title: '产品架构',
        hash: 'productFeatures',
    },
    {
        id: 1,
        title: '核心功能',
        hash: 'fucFeatures',
    },
    {
        id: 2,
        title: '产品优势',
        hash: 'productAdvantages',
    },
    {
        id: 3,
        title: '应用场景',
        hash: 'typicalCase',
    },
    {
        id: 4,
        title: '交流支持',
        hash: 'support',
    },
    {
        id: 5,
        title: '服务模式',
        hash: 'serviceMode',
    },
    {
        id: 6,
        title: '生态产品',
        hash: 'products',
    },
];

export const productNav = {
    title: '百度智能云千帆大模型服务与开发平台',
    nav: productTitle,
    buttonGroup: [
        {
            text: '企业咨询',
            href: 'https://cloud.baidu.com/survey/qianfanmb.html',
            type: 'default',
            class: 'default-btn',
            id: 0,
            trackInfo: {
                'data-track-category': '千帆产品页PC-nav',
                'data-track-name': '主按钮',
                'data-track-value': '企业咨询',
            },
            trackInfo_m: {
                'data-track-category': '千帆产品页wise-nav',
                'data-track-name': '主按钮',
                'data-track-value': '企业咨询',
            },
        },
        {
            text: '在线体验',
            href: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest',
            type: 'primary',
            class: 'primary-btn',
            id: 1,
            trackInfo: {
                'data-track-category': '千帆产品页PC-nav',
                'data-track-name': '主按钮',
                'data-track-value': '在线体验',
            },
            trackInfo_m: {
                'data-track-category': '千帆产品页wise-nav',
                'data-track-name': '主按钮',
                'data-track-value': '在线体验',
            },
        },
    ],
};

export const productTitle_m = [
    {
        id: 0,
        title: '产品架构',
        hash: 'product-features',
    },

    {
        id: 1,
        title: '产品功能',
        hash: 'fuc-features',
    },
    {
        id: 2,
        title: '大模型服务',
        hash: 'model',
    },
    {
        id: 3,
        title: '应用范式',
        hash: 'typical-normal',
    },
    {
        id: 4,
        title: '应用场景',
        hash: 'usecase',
    },
    {
        id: 5,
        title: '产品优势',
        hash: 'product-superiority',
    },
    {
        id: 6,
        title: '服务模式',
        hash: 'deployment',
    },
    {
        id: 7,
        title: '支持交流',
        hash: 'interchange',
    },
    {
        id: 8,
        title: '相关产品',
        hash: 'product-list',
    },
];

export const model = {
    data: [
        {
            name: 'Meta-Llama-3-8B-Instruct',
            // icon: require('assets/wenxin/ernie-bot.png').default,
            nameDesc:
                '模型由Meta开源， <a href="https://huggingface.co/meta-llama/Meta-Llama-3-8B" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Meta-Llama-3-8B-Instruct" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型由Meta开源，， <a href="https://huggingface.co/meta-llama/Meta-Llama-3-8B" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Meta-Llama-3-8B-Instruct" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['Meta (开源)'],
            type: '文本生成',
            // tag: '高性能',
            // tagClass: 'performance',
            // eslint-disable-next-line max-len
            desc: 'Meta-Llama-3-8B是Meta AI于2024年4月18日发布的Meta Llama 3系列的8B参数大语言模型，擅长语言细微差别、上下文理解、代码生成以及翻译和对话生成等复杂任务。Meta-Llama-3-8B-Instruct是8B参数的指令微调版本。',
            support: '支持训练调优与部署调用',
            // onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-4.0-8K',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/ilv62om62',
        },
        {
            name: 'Meta-Llama-3-70B-Instruct',
            nameOverflow: true,
            // icon: require('assets/wenxin/ernie-bot.png').default,
            nameDesc:
                '模型由Meta开源， <a href="https://huggingface.co/meta-llama/Meta-Llama-3-70B" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Meta-Llama-3-70B-Instruct" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型由Meta开源，， <a href="https://huggingface.co/meta-llama/Meta-Llama-3-70B" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Meta-Llama-3-70B-Instruct" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['Meta (开源)'],
            type: '文本生成',
            // tag: '旗舰级',
            // tagClass: 'flagship',
            // eslint-disable-next-line max-len
            desc: 'Meta-Llama-3-70B是Meta AI于2024年4月18日发布的Meta Llama 3系列的70B参数大语言模型，擅长语言细微差别、上下文理解、代码生成以及翻译和对话生成等复杂任务。Meta-Llama-3-70B-Instruct是70B参数的指令微调版本。',
            support: '支持部署调用',
            // onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-4.0-8K',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/3lv6364k8',
        },
        {
            name: 'DeepSeek-V3',
            icon: require('assets/wenxin/deepseek-icon.png').default,
            nameDesc: '',
            brand: ['深度求索'],
            type: '文本生成',
            desc: '杭州深度求索人工智能基础技术研究有限公司自研的 MoE 模型，在百科知识、数学推理等多项任务上优势突出，评测成绩在主流榜单中位列开源模型榜首。',
            support: '支持在线体验和调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/LLM/DeepSeek-V3',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Fm2vrveyu',
        },
        {
            name: 'DeepSeek-R1',
            icon: require('assets/wenxin/deepseek-icon.png').default,
            nameDesc: '',
            brand: ['深度求索'],
            type: '文本生成',
            desc: '杭州深度求索人工智能基础技术研究有限公司自研，在数学、代码、自然语言推理等任务上性能表现优异。',
            support: '支持在线体验和调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/LLM/DeepSeek-R1',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Fm2vrveyu',
        },
        {
            name: 'ERNIE 4.0 Turbo',
            icon: require('assets/wenxin/ernie-bot.png').default,
            nameDesc: '',
            brand: ['百度'],
            type: '文本生成',
            tag: '旗舰级',
            tagClass: 'flagship',
            desc: '百度自研的旗舰级超大规模⼤语⾔模型，综合效果表现出色，广泛适用于各领域复杂任务场景；支持自动对接百度搜索插件，保障问答信息时效。相较于ERNIE 4.0在性能表现上更优秀',
            support: '支持部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-4.0-Turbo-8K',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/7lxwwtafj',
        },
        {
            name: 'ERNIE 4.0',
            icon: require('assets/wenxin/ernie-bot.png').default,
            nameDesc: '',
            brand: ['百度'],
            type: '文本生成',
            tag: '旗舰级',
            tagClass: 'flagship',
            desc: '百度自研的旗舰级超大规模⼤语⾔模型，相较ERNIE 3.5实现了模型能力全面升级，广泛适用于各领域复杂任务场景；支持自动对接百度搜索插件，保障问答信息时效。',
            support: '支持部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-4.0-8K',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/clntwmv7t',
        },
        {
            name: 'ERNIE 3.5',
            icon: require('assets/wenxin/ernie-bot.png').default,
            nameDesc: '',
            brand: ['百度'],
            type: '文本生成',
            tag: '旗舰级',
            tagClass: 'flagship',
            desc: '百度自研的旗舰级大规模⼤语⾔模型，覆盖海量中英文语料，具有强大的通用能力，可满足绝大部分对话问答、创作生成、插件应用场景要求；支持自动对接百度搜索插件，保障问答信息时效。',
            support: '支持部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-3.5-8K',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/jlil56u11',
        },
        {
            name: 'ERNIE Speed',
            icon: require('assets/wenxin/ernie-bot.png').default,
            nameDesc: '',
            brand: ['百度'],
            type: '文本生成',
            tag: '高性能',
            tagClass: 'performance',
            desc: '百度2024年最新发布的自研高性能大语言模型，通用能力优异，适合作为基座模型进行精调，更好地处理特定场景问题，同时具备极佳的推理性能。',
            support: '支持训练调优与部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-Speed-8K',
            // deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/detail/11852',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/klqx7b1xf',
        },
        {
            name: 'ERNIE Lite',
            icon: require('assets/wenxin/ernie-bot.png').default,
            nameDesc: '',
            brand: ['百度'],
            type: '文本生成',
            tag: '轻量级',
            tagClass: 'performance',
            desc: '百度自研的轻量级大语言模型，兼顾优异的模型效果与推理性能，适合低算力AI加速卡推理使用。',
            support: '支持训练调优与部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-Lite-8K',
            // deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/detail/2',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/dltgsna1o',
        },
        {
            name: 'ERNIE Tiny',
            icon: require('assets/wenxin/ernie-bot.png').default,
            brand: ['百度'],
            type: '文本生成',
            tag: '超高性能',
            tagClass: 'performance',
            desc: '百度自研的超高性能大语言模型，部署与精调成本在文心系列模型中最低。',
            support: '支持训练调优与部署调用',
            // onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE Tiny',  // 3.18 上线
            // deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/detail/am-xgk30z76e4gs',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/7lsvf68uw',
        },
        {
            name: 'ERNIE Character',
            icon: require('assets/wenxin/ernie-bot.png').default,
            brand: ['百度'],
            type: '文本生成',
            tag: '专用版',
            tagClass: 'special',
            // eslint-disable-next-line max-len
            desc: '百度自研的垂直场景大语言模型，适合游戏NPC、客服对话、对话角色扮演等应用场景，人设风格更为鲜明、一致，指令遵循能力更强，推理性能更优。',
            support: '支持部署调用',
            // applyTest: 'https://cloud.baidu.com/survey/model-evaluating.html',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-Character-8K',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Eltxyhpve',
        },
        {
            name: 'ERNIE Functions',
            icon: require('assets/wenxin/ernie-bot.png').default,
            brand: ['百度'],
            type: '文本生成',
            tag: '专用版',
            tagClass: 'special',
            desc: '百度自研的垂直场景大语言模型，适合对话问答中的外部工具使用和业务函数调用场景，结构化回答合成能力更强、输出格式更稳定，推理性能更优。',
            support: '支持部署调用',
            // applyTest: 'https://cloud.baidu.com/survey/model-evaluating.html',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-Functions-8K',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/5ltxyqupn',
        },
        // {
        //     name: 'ERNIE Speed-AppBuilder',
        //     icon: require('assets/wenxin/ernie-bot.png').default,
        //     brand: ['百度'],
        //     type: '文本生成',
        //     tag: '专用版',
        //     tagClass: 'special',
        // eslint-disable-next-line max-len
        //     desc: '千帆AppBuilder专用版模型，针对企业级大模型应用进行了专门的指令调优，在问答场景、智能体相关场景可以获得同等规模模型下更好的效果，需配合“百度智能云千帆AppBuilder”产品使用或结合“AppBuilder-SDK”单独使用',
        //     support: '支持部署调用',
        //     onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE Speed-AppBuilder',
        //     doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Alp0kdm0n'
        // },
        {
            name: '文心一格',
            icon: require('assets/wenxin/ernie-bot.png').default,
            brand: ['百度'],
            type: '图像生成',
            tag: '旗舰级',
            tagClass: 'flagship',
            desc: '百度自主研发的跨模态图像生成大模型，创新知识增强的混合专家建模，是全球首个知识增强的AI作画大模型，在语义控制、图像细节、中文理解等方面优势显著，已作为基础模型应用在文心一格等相关业务上。',
            support: '支持训练调优与部署调用',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/clqx8tbl0',
        },
        {
            name: 'Embedding-V1',
            nameDesc: '',
            brand: ['百度'],
            type: '文本表示',
            desc: 'Embedding-V1是基于百度文心大模型技术的文本表示模型，将文本转化为用数值表示的向量形式，用于文本检索、信息推荐、知识挖掘等场景。',
            support: '支持部署调用',
            // onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/Embedding-V1',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/alj562vvu',
        },
        {
            name: 'Qianfan-BLOOMZ-7B-compressed',
            // pc模型名称超出一行
            nameOverflow: true,
            nameDesc:
                '模型基于BigScience开源模型增强，<br /> <a href="https://huggingface.co/bigscience/bloomz-7b1-mt" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Qianfan-BLOOMZ-7B-compressed" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a> ',
            nameDesc_m:
                '模型基于BigScience开源模型增强， <a href="https://huggingface.co/bigscience/bloomz-7b1-mt" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Qianfan-BLOOMZ-7B-compressed" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a> ',
            brand: ['百度(增强)', 'BigScience(开源)'],
            type: '文本生成',
            desc: '千帆团队在BLOOMZ-7B基础上的压缩版本，融合量化、稀疏化等技术，显存占用降低30%以上',
            support: '支持部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/Qianfan-BLOOMZ-7B-compressed',
            deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model-version/detail/3/5595',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/nllyzpcmp',
        },
        {
            name: 'Qianfan-Chinese-Llama-2-7B',
            nameOverflow: true,
            nameDesc:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-7b" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-7B" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-7b" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-7B" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['百度 (增强)', 'Meta (开源)'],
            type: '文本生成',
            desc: '千帆团队在Llama-2-7b基础上的中文增强版本，在CMMLU、C-EVAL等中文数据集上表现优异',
            support: '支持训练调优与部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/Qianfan-Chinese-Llama-2-7B',
            deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model-version/detail/2258/5600',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Sllyztytp',
        },
        {
            name: 'Qianfan-Chinese-Llama-2-7B-32K',
            nameOverflow: true,
            nameDesc:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-7b" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-7B-32K" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-7b" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-7B-32K" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['百度 (增强)', 'Meta (开源)'],
            type: '文本生成',
            desc: '千帆团队在Qianfan-Chinese-Llama-2-7B基础上的增强版本，支持32K上下文',
            support: '支持训练调优与部署调用',
            deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model-version/detail/2258/16098',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Wlrimb8aw',
        },
        {
            name: 'Qianfan-Chinese-Llama-2-13B-v2',
            nameOverflow: true,
            nameDesc:
                '模型基于Meta开源模型框架进行预训练， <a href="https://huggingface.co/meta-llama/Llama-2-7b" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-13B-v2" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型基于Meta开源模型框架进行预训练， <a href="https://huggingface.co/meta-llama/Llama-2-7b" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-13B-v2" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['百度 (增强)', 'Meta (开源)'],
            type: '文本生成',
            desc: '千帆团队基于Llama2架构开发的130亿参数预训练大语言模型，在1T+ tokens的高质量自有语料上从零开始训练，支持中英双语，上下文窗口长度为4K。推理效果整体优于同参数量级开源模型',
            support: '支持训练调优与部署调用',
            deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/detail/am-p6rz53tkgc7e',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/zltpk9tto',
        },
        {
            name: 'Qianfan-Chinese-Llama-2-13B-v1',
            nameOverflow: true,
            nameDesc:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-13b-hf" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-13B" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-13b-hf" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-13B" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['百度 (增强)', 'Meta (开源)'],
            type: '文本生成',
            desc: '千帆团队在Llama-2-13b基础上的中文增强版本，在CMMLU、C-EVAL等中文数据集上表现优异',
            support: '支持训练调优与部署调用',
            onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/Qianfan-Chinese-Llama-2-13B',
            deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model-version/detail/2259/9166',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/8lo479b4b',
        },
        {
            name: 'Qianfan-Chinese-Llama-2-70B',
            nameOverflow: true,
            nameDesc:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-13b-hf" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-70B" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-13b-hf" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Qianfan-Chinese-Llama-2-70B" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['百度 (增强)', 'Meta (开源)'],
            type: '文本生成',
            desc: '千帆团队在Llama-2-70b基础上的中文增强版本，在CMMLU、C-EVAL等中文数据集上表现优异',
            support: '支持部署调用',
            deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/detail/am-rwhr5173mxre',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/cltpkdcwy',
        },
        {
            name: 'Qianfan-Llama-2-70B-compressed',
            nameOverflow: true,
            nameDesc:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-70b-chat-hf" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页PC-内置丰富优质的大模型能力"  data-track-name="Qianfan-Llama-2-70B-compressed" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            nameDesc_m:
                '模型基于Meta开源模型增强， <a href="https://huggingface.co/meta-llama/Llama-2-70b-chat-hf" target="_blank" rel="noopener noreferrer" data-track-category="千帆产品页wise-内置丰富优质的大模型能力"  data-track-name="Qianfan-Llama-2-70B-compressed" data-track-value="了解更多">了解更多<i class="tzfont tzfont-arrow-right" ></i></a>',
            brand: ['百度 (增强)', 'Meta (开源)'],
            type: '文本生成',
            desc: 'Qianfan-Llama2-70B-compressed是千帆团队在Llama2-70B基础上的压缩版本，融合量化、稀疏化、算子优化等压缩加速技术，大幅降低模型推理资源占用。',
            support: '支持部署调用',
            deployment: 'https://console.bce.baidu.com/qianfan/modelcenter/model-version/detail/2260/12616',
            doc: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/floqj7kuh',
        },
    ],
};

export const productFeature = {
    title: '功能覆盖大模型全生命周期',
};

export const typicalCase = [
    {
        title: '电商',
        content: '大模型帮助电商平台优化用户体验，提升销售额度，降低运营成本。',
        img: require('assets/wenxin/e-commerce.jpg').default,
        imgMobile: require('assets/wenxin/commercial_m.jpg').default,
        fontColor: '#fff',
    },
    {
        title: '短视频',
        content: '大模型辅助生成图文内容，启迪创意灵感，提高创作效率。',
        img: require('assets/wenxin/short-video.jpg').default,
        imgMobile: require('assets/wenxin/video_m.jpg').default,
        fontColor: '#fff',
    },
    {
        title: '教育',
        content: '大模型辅助个性化教育发展规划，推动精准决策，提升教学效果。',
        img: require('assets/wenxin/education.jpg').default,
        imgMobile: require('assets/wenxin/education_m.jpg').default,
        fontColor: '#000',
    },
    {
        title: '游戏',
        content: '大模型辅助游戏设计、玩法，优化游戏体验，提升用户日活。',
        img: require('assets/wenxin/game.jpg').default,
        imgMobile: require('assets/wenxin/game_m.jpg').default,
        fontColor: '#000',
    },
    {
        title: '医疗',
        content: '大模型辅助医疗诊断并提供治疗建议，提供更准确、全面的疾病检测与预测。',
        img: require('assets/wenxin/medical-treatment.jpg').default,
        imgMobile: require('assets/wenxin/medical_m.jpg').default,
        fontColor: '#fff',
    },
    {
        title: '金融',
        content: '大模型辅助银行与金融机构进行风险评估、市场预测与投资决策。',
        img: require('assets/wenxin/financial.jpg').default,
        imgMobile: require('assets/wenxin/finance_m.jpg').default,
        fontColor: '#fff',
    },
];

export const support = {
    name: '完善的技术支持与社区交流',
    nameMobile: '技术支持与社区交流',
    arr: [
        {
            title: '帮助手册',
            content: '探索和发现千帆平台大模型能力，体验大模型',
            links: [
                {
                    text: '千帆平台文档',
                    url: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Slfmc9dds',
                },
                {
                    text: '定价说明',
                    url: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Blfmc9dlf',
                },
            ],
        },
        {
            title: '技术指南',
            content: '千帆大模型技术开发文档，帮助使用API或SDK',
            links: [
                {
                    text: 'API文档',
                    url: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/flfmc9do2',
                },
                {
                    text: 'SDK文档',
                    url: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/wlmhm7vuo',
                },
            ],
        },
        {
            title: '千帆社区',
            content: '了解大模型最新动态，与开发者一起交流学习',
            links: [
                {
                    text: '千帆社区',
                    url: 'https://cloud.baidu.com/qianfandev',
                },
            ],
        },
    ],
};

export const products = {
    name: '新一代人工智能生态产品',
    arr: [
        {
            title: '百度智能云千帆AppBuilder',
            content: '低门槛解决大模型应用落地最后一公里',
            links: [
                {
                    text: '了解更多',
                    url: 'https://qianfan.cloud.baidu.com/appbuilder',
                },
            ],
        },
        {
            title: '千帆全功能AI开发平台BML',
            content: '基于文心大模型完成一站式AI开发',
            links: [
                {
                    text: '了解更多',
                    url: 'https://cloud.baidu.com/product/bml',
                },
            ],
        },
        {
            title: '智能代码助手 Baidu Comate',
            content: '提升编码效率，释放“十倍”软件生产力',
            links: [
                {
                    text: '了解更多',
                    url: 'https://cloud.baidu.com/product/comate-public.html',
                },
            ],
        },
        {
            title: '增值服务',
            content: '提供培训、咨询等技术支持服务',
            links: [
                {
                    text: '了解更多',
                    url: 'https://cloud.baidu.com/product/llmservice.html',
                },
            ],
        },
    ],
};

export const MODEL_FEATURE = {
    title: '可以体验以下功能',
    types: [
        {
            title: '大模型推理',
            list: [
                {
                    key: 1,
                    img: require('assets/wenxin/model/1.png').default,
                    label: '创建应用获取密钥',
                },
                {
                    key: 2,
                    img: require('assets/wenxin/model/2.png').default,
                    label: '进入体验中心进行交互式快速体验',
                },
                {
                    key: 3,
                    img: require('assets/wenxin/model/3.png').default,
                    label: '调用API或SDK进行业务集成',
                },
                {
                    key: 4,
                    img: require('assets/wenxin/model/4.png').default,
                    label: '查看调用监控实时数据，确保服务稳定',
                },
            ],
            btns: [
                {
                    key: 1,
                    label: '在线体验',
                    href: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest',
                },
                {
                    key: 2,
                    label: '使用推理服务',
                    href: 'https://console.bce.baidu.com/qianfan/ais/console/onlineService',
                },
            ],
        },
        {
            title: '大模型精调',
            list: [
                {
                    key: 1,
                    img: require('assets/wenxin/model/1.png').default,
                    label: '准备训练数据，洞察+处理，打造高质量数据',
                },
                {
                    key: 2,
                    img: require('assets/wenxin/model/2.png').default,
                    label: '确定基础模型、精调方法和训练参数，启动训练',
                },
                {
                    key: 3,
                    img: require('assets/wenxin/model/3.png').default,
                    label: '模型训练完成，人工或自动评估模型效果',
                },
                {
                    key: 4,
                    img: require('assets/wenxin/model/4.png').default,
                    label: '模型部署为公有云服务，在线体验或接口调用',
                },
            ],
            btns: [
                {
                    key: 1,
                    label: '使用SFT',
                    href: 'https://console.bce.baidu.com/qianfan/train/ft/new?devType=1',
                },
                {
                    key: 2,
                    label: '使用Post-pretrain',
                    href: 'https://console.bce.baidu.com/qianfan/train/ft/new?devType=4',
                },
            ],
        },
    ],
};

export const reason = {
    title: '选择我们的理由',
    list: [
        {
            key: 1,
            label1: '更全面',
            label2: '最全工具链',
            label3: '覆盖大模型全生命周期',
            img: require('assets/wenxin/model/comprehensive.png').default,
            imgMobile: require('assets/wenxin/model/comprehensive_m.png').default,
        },
        {
            key: 2,
            label1: '更精准',
            label2: '最佳中文理解',
            label3: '凝聚文心大模型最佳实践',
            img: require('assets/wenxin/model/precision.png').default,
            imgMobile: require('assets/wenxin/model/precision_m.png').default,
        },
        {
            key: 3,
            label1: '更高速',
            label2: '集成先进的加速框架',
            label3: '训练与推理性能大幅提升',
            img: require('assets/wenxin/model/high.png').default,
            imgMobile: require('assets/wenxin/model/high_m.png').default,
        },
        {
            key: 4,
            label1: '更经济',
            label2: '成本最高降低50%',
            label3: '训练与推理成本大幅降低',
            img: require('assets/wenxin/model/economies.png').default,
            imgMobile: require('assets/wenxin/model/economies_m.png').default,
        },
    ],
};

export const serviceMode = [
    {
        title: '私有化',
        content: '适合强数据安全与隐私需求的场景',
        content_icon: require('assets/wenxin/contact-us.png').default,
        desc: ['独立软件平台交付，灵活可靠', '资源数据自有可控，安全保障', '深度集成企业系统，统一管理'],
        btn: '我要咨询',
        link: 'https://cloud.baidu.com/survey/consulting.html',
    },
    {
        title: '公有云',
        content: '适合快速体验效果并训练模型的场景',
        content_icon: require('assets/wenxin/contact-us-white.png').default,
        desc: ['公共资源服务推理，超高性价比', '私有资源服务托管，保障请求并发', '7 × 24 小时工单支持，在线技术服务'],
        btn: '立即使用',
        link: process.env.WX_TEST_HREF,
    },
    {
        title: '软硬一体',
        content_icon: require('assets/wenxin/contact-us.png').default,
        content: '适合开箱即用且高可用需求的场景',
        desc: ['软硬一体交付，高可用保证', '多算力资源适配，国产化支持', '开箱即用，安全高效'],
        btn: '我要咨询',
        link: 'https://cloud.baidu.com/survey/consulting.html',
    },
];

export const serviceMode_m = [
    {
        title: '公有云',
        content: '适合快速体验效果并训练模型的场景',
        content_icon: require('assets/wenxin/contact-us-white-m.png').default,
        desc: ['公共资源服务推理，超高性价比', '私有资源服务托管，保障请求并发', '7 × 24 小时工单支持，在线服务'],
        desc_icon: require('assets/wenxin/delivery-check.png').default,
        btn: '立即使用',
        link: process.env.WX_TEST_HREF,
    },
    {
        title: '私有化',
        content: '适合强数据安全与隐私需求的场景',
        content_icon: require('assets/wenxin/contact-us-m.png').default,
        desc: ['独立软件平台交付，灵活可靠', '资源数据自有可控，安全保障', '深度集成企业系统，统一管理'],
        desc_icon: require('assets/wenxin/delivery-check.png').default,
        btn: '我要咨询',
        link: 'https://cloud.baidu.com/survey/consulting.html',
    },
    {
        title: '软硬一体',
        content_icon: require('assets/wenxin/contact-us-m.png').default,
        content: '适合开箱即用且高可用需求的场景',
        desc: ['软硬一体交付，高可用保证', '多算力资源适配，国产化支持', '开箱即用，安全高效'],
        desc_icon: require('assets/wenxin/delivery-check.png').default,
        btn: '我要咨询',
        link: 'https://cloud.baidu.com/survey/consulting.html',
    },
];

export const footer = {
    about: {
        title: '关于我们',
        des: [
            {
                text: '百度智能云千帆大模型服务与开发平台，一站式企业级大模型开发及服务运行平台',
                id: 0,
            },
            {
                text: '文心大模型企业级服务唯一入口，并且涵盖丰富的第三方开源大模型',
                id: 1,
            },
            {
                text: '提供高可用及高效价比的生成式AI服务及全流程模型开发工具链',
                id: 2,
            },
            {
                text: '从数据管理到服务云端部署，完备的流程助力各行业生成式AI应用需求落地',
                id: 3,
            },
        ],
    },
    resources: {
        title: '社区与资源',
        list: [
            {
                id: 0,
                text: '千帆社区',
                href: 'https://cloud.baidu.com/qianfandev',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '千帆社区',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '千帆社区',
                },
            },
            {
                id: 1,
                text: '专家服务',
                href: 'https://cloud.baidu.com/doc/support/index.html#expert',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '专家服务',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '专家服务',
                },
            },
            {
                id: 2,
                text: '文档中心',
                href: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/7ltgucw50',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '文档中心',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '文档中心',
                },
            },
            {
                id: 3,
                text: 'SDK中心',
                href: 'https://cloud.baidu.com/doc/Developer/index.html',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-banner',
                    'data-track-name': '主按钮',
                    'data-track-value': 'SDK中心',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-banner',
                    'data-track-name': '主按钮',
                    'data-track-value': 'SDK中心',
                },
            },
            {
                id: 4,
                text: 'API平台',
                href: 'https://cloud.baidu.com/doc/API/index.html',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': 'API平台',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': 'API平台',
                },
            },
            {
                id: 5,
                text: '培训与认证',
                href: 'https://cloud.baidu.com/doc/support/index.html#training',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '培训与认证',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '培训与认证',
                },
            },
        ],
    },
    service: {
        title: '服务与支持',
        list: [
            {
                id: 0,
                text: '支持热线：400-920-8999转1',
            },
            {
                id: 1,
                text: '我的工单',
                href: 'https://console.bce.baidu.com/ticket/#/ticket/list',
                // href: 'https://console.bce.baidu.com/support/?u=ModelBuilder#/ticket/#/ticket/create?productId=279',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '我的工单',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '我的工单',
                },
            },
            {
                id: 2,
                text: '合作咨询',
                href: 'https://cloud.baidu.com/znzs/pre-sale#/znzs/presale/https%253A%252F%252Fcloud.baidu.com%252Fsupport%252Fplan.html',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '合作咨询',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '合作咨询',
                },
            },
        ],
    },
    qrCode: require('assets/wenxin/rcode.png').default,
};
